import React from 'react';
import t from '../Translation/Translation';
import { useEffect, useState, useRef } from 'react';
import conf from '../../config.json';

import { useNavigate, useLocation, useParams } from 'react-router';
import { App } from '@capacitor/app';
import { IonPage, IonHeader, IonToolbar, IonButtons, IonButton, IonTitle, IonContent, IonModal, IonItem, IonInput, IonIcon} from '@ionic/react';
import { Form } from 'react-bootstrap';
import { arrowBack, reloadOutline, copyOutline } from 'ionicons/icons';
import { Loader } from 'citric_components';
import { logD } from '../Util/Util';
import Header from '../Dashboard/Header';

export default function WebView(props) {
    //const [url, setUrl] = useState(props.url);
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();

    const [url, setUrl] = useState(props.url);
    //const url = props.url;
    const title = props.title;
    const type = props.type;

    let locationKey = location.key;

    const [loading, setLoading] = useState(true);
    const [modalOpen, setModalOpen] = useState(false);
    //const [response, setResponse] = useState(props.interviewer != null ? props.interviewer : params.id);
    const [response, setResponse] = useState(props.response != null ? props.response : (props.interviewer != null && type === 'cati' ? props.interviewer : params.id));
    console.log(props.response);
    const [launch, setLaunch] = useState(params.id);
    const [isBegin, setIsBegin] = useState(type !== 'cati' ? true : false);
    const [isAplazar, setIsAplazar] = useState(false);
    const [state, setState] = useState('OTRO');
    const [date, setDate] = useState(null);

    const [showQuest, setShowQuest] = useState(false);
    const [showSC, setShowSC] = useState(false);
    const [editQuota, setEditQuota] = useState(false);

    const modal = useRef(null);
    const input = useRef(null);

    function back() {
        if(props.token.r != 0 && (type === 'survey' || type === 'survey_start'))
            setModalOpen(true);
        else if(type === 'cati')
            setModalOpen(true);
        else if(props.interviewed != null) {
            console.log("setResponse " + response)
            props.setResponse(response);
            close();
        } else
            close();
    }

    function begin() {
        setIsBegin(true);
        changeState(props.assign, 'EMP_ENTREVISTA');
    }

    function timeout(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    function setNewState(newState) {
        if(newState === 'APLAZAR') {
            setIsAplazar(true);
        } else {
            setIsAplazar(false);
            setDate(null);
        }
        setState(newState);
    }

    function reload() {
        var link = url;
        var show_loi = document.getElementById('show_loi') ? document.getElementById('show_loi').checked : false;
        var show_qae = document.getElementById('show_qae') ? document.getElementById('show_qae').checked : false;
        var show_quest = document.getElementById('show_quest') ? document.getElementById('show_quest').checked : false;
        var show_access = document.getElementById('show_access') ? document.getElementById('show_access').checked : false;
        var show_sc = document.getElementById('show_sc') ? document.getElementById('show_sc').checked : false;
        var edit_quota = document.getElementById('edit_quota') ? document.getElementById('edit_quota').checked : false;
        var cross_quota = document.getElementById('cross_quota') ? document.getElementById('cross_quota').checked : false;

        if(show_loi) {
            link = link.replace('&sl=1', '');
            link += '&sl=1';
        } else {
            link = link.replace('&sl=1', '');
        }

        if(show_qae) {
            link = link.replace('&qae=1', '');
            link += '&qae=1';
        } else {
            link = link.replace('&qae=1', '');
        }

        if(show_quest) {
            link = link.replace('&qn=1', '');
            link += '&qn=1';
        } else {
            link = link.replace('&qn=1', '');
        }

        if(show_sc) {
            link = link.replace('&sc=1', '');
            link += '&sc=1';
        } else {
            link = link.replace('&sc=1', '');
        }

        if(show_access) {
            link = link.replace('&acc=1', '');
            link += '&acc=1';
        } else {
            link = link.replace('&acc=1', '');
        }

        if(edit_quota) {
            link = link.replace('&eqa=1', '');
            link += '&eqa=1';
        } else {
            link = link.replace('&eqa=1', '');
        }

        if(cross_quota) {
            link = link.replace('&cqa=1', '');
            link += '&cqa=1';
        } else {
            link = link.replace('&cqa=1', '');
        }

        setUrl(link);
    }

    function copy() {
        var link = url;
        var show_loi = document.getElementById('show_loi') ? document.getElementById('show_loi').checked : false;
        var show_qae = document.getElementById('show_qae') ? document.getElementById('show_qae').checked : false;
        var show_quest = document.getElementById('show_quest') ? document.getElementById('show_quest').checked : false;
        var show_access = document.getElementById('show_access') ? document.getElementById('show_access').checked : false;
        var show_sc = document.getElementById('show_sc') ? document.getElementById('show_sc').checked : false;
        var edit_quota = document.getElementById('edit_quota') ? document.getElementById('edit_quota').checked : false;
        var cross_quota = document.getElementById('cross_quota') ? document.getElementById('cross_quota').checked : false;

        link = link.replace('&nomb=1', '');

        if(show_loi) {
            link = link.replace('&sl=1', '');
            link += '&sl=1';
        } else {
            link = link.replace('&sl=1', '');
        }

        if(show_qae) {
            link = link.replace('&qae=1', '');
            link += '&qae=1';
        } else {
            link = link.replace('&qae=1', '');
        }

        if(show_quest) {
            link = link.replace('&qn=1', '');
            link += '&qn=1';
        } else {
            link = link.replace('&qn=1', '');
        }

        if(show_sc) {
            link = link.replace('&sc=1', '');
            link += '&sc=1';
        } else {
            link = link.replace('&sc=1', '');
        }

        if(show_access) {
            link = link.replace('&acc=1', '');
            link += '&acc=1';
        } else {
            link = link.replace('&acc=1', '');
        }

        if(edit_quota) {
            link = link.replace('&eqa=1', '');
            link += '&eqa=1';
        } else {
            link = link.replace('&eqa=1', '');
        }

        if(cross_quota) {
            link = link.replace('&cqa=1', '');
            link += '&cqa=1';
        } else {
            link = link.replace('&cqa=1', '');
        }

        navigator.clipboard.writeText(link);
        //setUrl(link);
    }

    useEffect(() => {
        locationKey = location.key;
    }, [location]);

    useEffect(() => {
        if(!loading && type === 'survey_start') {
            setTimeout(function(){
                console.log("setResponse " + response + " " + props.response)
                if(props.response == null) {
                    getIdResponse();
                }
            }, 1000);
        }
    }, [loading]);

    function confirm() {
        modal.current?.dismiss(input.current?.value, 'confirm');
    }

    async function onWillDismiss(event) {
        if (event.detail.role === 'confirm') {
            //alert(`Hello, ${event.detail.data}!`);
            if(type === 'cati') {
                await changeState(props.assign, state, event.detail.data, date);
                console.log(event);
            } else {
                await addNote(event.detail.data);
            }
        }
        close();
    }

    async function close() {
        //props.setUrl(null);
        var cont = 0;
        while(window.history.state.key === locationKey) {
            navigate(-1);
            cont++;
            await timeout(100);
            if(cont > 500) break;
        }
    }

    App.addListener('backButton', ({canGoBack}) => {
        
        if(!canGoBack){
          App.exitApp();
        } else {
          back();
        }
    });

    async function addNote(note) {
        let fd = new URLSearchParams();
        fd.append("idC", response);
        fd.append("idU", props.token.u);
        fd.append("note", note);
        //const url = conf.BEprotocol + '://' + conf.BEhost + ':' + conf.BEport + '/' + conf.BEcontext + '/rest/dash/all';
        const url = conf.BEprotocol + '://' + conf.BEhost + ':' + conf.BEport + '/' + conf.BEcontext + '/rest/action/addNote';
        await fetch(url, {
            method: 'POST',
            headers: {
                'authorization': 'Bearer ' + props.token.token
            },
            body: fd,
        })
        .then(props.handleError)
        .then((response) => response.json())
        .then((data) => {
            logD("WebView", data);
        }).catch((e) => {
            props.setShowToast(true);
        });
    }

    async function getIdResponse() {
        let fd = new URLSearchParams();
        fd.append("idL", launch);
        fd.append("idU", props.token.u);
        fd.append("note", props.keyNote);
        //const url = conf.BEprotocol + '://' + conf.BEhost + ':' + conf.BEport + '/' + conf.BEcontext + '/rest/dash/all';
        const url = conf.BEprotocol + '://' + conf.BEhost + ':' + conf.BEport + '/' + conf.BEcontext + '/rest/action/getIdResponse';
        await fetch(url, {
            method: 'POST',
            headers: {
                'authorization': 'Bearer ' + props.token.token
            },
            body: fd,
        })
        .then((response) => props.handleError(response))
        //.then((response) => response.json())
        .then((data) => {
            logD("WebView", data);
            setResponse(data);
        }).catch((e) => {
            props.setShowToast(true);
            props.handleError(e);
        });
    }

    function changeState(asign, code, note, date) {
        let fd = new URLSearchParams();
        fd.append("idL", props.launch.idLaunch);
        fd.append("idU", props.interviewer);
        fd.append("idA", asign);
        fd.append("code", code);
        if(note)
            fd.append("reason", note);
        if(date && date != null)
            fd.append("timestamp", Date.parse(date));
            //console.log(date);

        const url = conf.BEprotocol + '://' + conf.BEhost + ':' + conf.BEport + '/' + conf.BEcontext + '/rest/action/changeState';
        fetch(url, {
            method: 'POST',
            headers: {
                'authorization': 'Bearer ' + props.token.token
            },
            body: fd,
        })
        .then(props.handleError)
        .then((response) => response.json())
        .then((data) => {
            logD("WebView", data);
        }).catch((e) => {
            props.setShowToast(true);
        });
    }

    return (
        <IonPage id="webview">
            <IonHeader>
                <Header lang={props.lang} setLang={props.setLang} token={props.token} setToken={props.setToken}/>
                <IonToolbar className="toolbar-azul">
                    <IonButtons slot="start">
                        <IonButton onClick={() => back()}><IonIcon icon={arrowBack}></IonIcon></IonButton>
                    </IonButtons>
                    <IonTitle>{title}</IonTitle>
                    <IonButtons slot="end">
                        {!isBegin && <IonButton onClick={() => begin()}>{t('begin')}</IonButton>}
                        {type === "tracking" && props.token.r == 1 &&
                            <>
                                <Form.Check
                                    type="switch"
                                    id="show_loi"
                                    label={t('loi')}
                                    className="me-2"
                                />
                                <Form.Check
                                    type="switch"
                                    id="show_quest"
                                    label={t('questions')}
                                    className="me-2"
                                />
                                <Form.Check
                                    type="switch"
                                    id="show_sc"
                                    label={t('screenouts')}
                                    className="me-2"
                                />
                                <Form.Check
                                    type="switch"
                                    id="show_access"
                                    label={t('access')}
                                    className="me-2"
                                />
                                <Form.Check
                                    type="switch"
                                    id="edit_quota"
                                    label={t('edit_quotas')}
                                    className="me-2"
                                />
                                <Form.Check
                                    type="switch"
                                    id="cross_quota"
                                    label={t('cross_quotas')}
                                    className="me-2"
                                />
                                <IonButton onClick={() => reload()}><IonIcon icon={reloadOutline}></IonIcon>{t('Reload')}</IonButton>
                                <IonButton onClick={() => copy()}><IonIcon icon={copyOutline}></IonIcon>{t('Copy')}</IonButton>
                            </>
                        }

                        {type === "tracking" && props.token.r != 1 && props.userConfig != null && props.userConfig.optionsTracking  &&
                            <>
                                {props.userConfig.optionsTracking.loi && <Form.Check
                                    type="switch"
                                    id="show_loi"
                                    label={t('loi')}
                                    className="me-2"
                                />}
                                {props.userConfig.optionsTracking.qae && <Form.Check
                                    type="switch"
                                    id="show_qae"
                                    label={t('profile_quota')}
                                    className="me-2"
                                />}
                                {props.userConfig.optionsTracking.qn && <Form.Check
                                    type="switch"
                                    id="show_quest"
                                    label={t('questions')}
                                    className="me-2"
                                />}
                                {props.userConfig.optionsTracking.sc && <Form.Check
                                    type="switch"
                                    id="show_sc"
                                    label={t('screenouts')}
                                    className="me-2"
                                />}
                                {props.userConfig.optionsTracking.acc && <Form.Check
                                    type="switch"
                                    id="show_access"
                                    label={t('access')}
                                    className="me-2"
                                />}
                                {props.userConfig.optionsTracking.eqa && <Form.Check
                                    type="switch"
                                    id="edit_quota"
                                    label={t('edit_quotas')}
                                    className="me-2"
                                />} 
                                {props.userConfig.optionsTracking.cqa && <Form.Check
                                    type="switch"
                                    id="cross_quota"
                                    label={t('cross_quotas')}
                                    className="me-2"
                                />}
                                <IonButton onClick={() => reload()}><IonIcon icon={reloadOutline}></IonIcon>{t('Reload')}</IonButton>
                                {props.userConfig.optionsTracking.copy && <IonButton onClick={() => copy()}><IonIcon icon={copyOutline}></IonIcon>{t('Copy')}</IonButton>}
                            </>
                        }
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            <IonContent>
            {loading && <Loader />}
            {!isBegin && <p class="text-center">{t('click_begin_hangout')}</p>}
            {url != null && isBegin && <iframe
                id="webViewIframe"
                key={location.key}
                title={title}
                src={url}
                style={{ width: '100%', height: '99%' }}
                onLoad={() => setLoading(false)}
                >
            </iframe>}
            <IonModal ref={modal} isOpen={modalOpen} onWillDismiss={(event) => onWillDismiss(event)}>
                <IonHeader>
                    <IonToolbar>
                    <IonButtons slot="start">
                        <IonButton onClick={() => modal.current?.dismiss()}>{t('cancel')}</IonButton>
                    </IonButtons>
                    <IonTitle>{t('add_note')}</IonTitle>
                    <IonButtons slot="end">
                        <IonButton strong={true} onClick={() => confirm()}>
                            {t('confirm')}
                        </IonButton>
                    </IonButtons>
                    </IonToolbar>
                </IonHeader>
                <IonContent className="ion-padding">
                    <IonItem>
                    <IonInput
                        label={t('add a note')}
                        labelPlacement="stacked"
                        ref={input}
                        type="text"
                        placeholder={t('note')}
                    />
                    </IonItem>
                </IonContent>
            </IonModal>
            <IonModal ref={modal} isOpen={modalOpen} onWillDismiss={(event) => onWillDismiss(event)}>
                <IonHeader>
                    <IonToolbar>
                    <IonButtons slot="start">
                        <IonButton onClick={() => modal.current?.dismiss()}>{t('cancel')}</IonButton>
                    </IonButtons>
                    <IonTitle>{type === 'cati' ? t('change_state') : t('add a note')}</IonTitle>
                    <IonButtons slot="end">
                        <IonButton strong={true} onClick={() => confirm()}>
                            {t('confirm')}
                        </IonButton>
                    </IonButtons>
                    </IonToolbar>
                </IonHeader>
                <IonContent className="ion-padding">
                    <>
                    {type === 'cati' && 
                        <>
                            <div>
                                <Form.Check
                                    inline
                                    label={t('FIN_ENTREVISTA')}
                                    name="group1"
                                    type="radio"
                                    id='FIN_ENTREVISTA'
                                    onClick={() => setNewState('FIN_ENTREVISTA')}
                                />
                                <Form.Check
                                    inline
                                    label={t('NO_CONTINUA')}
                                    name="group1"
                                    type="radio"
                                    id='NO_CONTINUA'
                                    onClick={() => setNewState('NO_CONTINUA')}
                                />
                                <Form.Check
                                    inline
                                    label={t('NO_CONTESTA')}
                                    name="group1"
                                    type="radio"
                                    id='NO_CONTESTA'
                                    onClick={() => setNewState('NO_CONTESTA')}
                                />
                            </div>
                            <div>
                            <Form.Check
                                inline
                                label={t('ERROR_FAX')}
                                name="group1"
                                type="radio"
                                id='ERROR_FAX'
                                onClick={() => setNewState('ERROR_FAX')}
                            />
                            <Form.Check
                                inline
                                label={t('ERROR_TLF')}
                                name="group1"
                                type="radio"
                                id='ERROR_TLF'
                                onClick={() => setNewState('ERROR_TLF')}
                            />
                            <Form.Check
                                inline
                                label={t('ERROR_TLF_INC')}
                                name="group1"
                                type="radio"
                                id='ERROR_TLF_INC'
                                onClick={() => setNewState('ERROR_TLF_INC')}
                            />
                            </div>
                            <div>
                            <Form.Check
                                inline
                                label={t('APLAZAR')}
                                name="group1"
                                type="radio"
                                id='APLAZAR'
                                onClick={() => setNewState('APLAZAR')}
                            />
                            <Form.Check
                                inline
                                label={t('OTROS')}
                                name="group1"
                                type="radio"
                                id='OTROS'
                                onClick={() => setNewState('OTROS')}
                            />
                            </div>
                        </>
                    }
                    {
                        isAplazar &&
                        <input type="datetime-local" id="dateAplazar" name="dateAplazar" 
                            onChange={e => setDate(e.target.value)}
                            min={Date.now()}/>
                    }
                    <IonInput
                        label={t('add a note')}
                        labelPlacement="stacked"
                        ref={input}
                        type="text"
                        placeholder={t('note')}
                    />
                    </>
                </IonContent>
            </IonModal>
            </IonContent>
        </IonPage>
    );
}